import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';

export function withSessionRequired(Component) {
  return ({isLoggedIn, ...props}) => {
    if (!isLoggedIn) {
      hashHistory.push('/login');
    }

    return isLoggedIn ? React.createElement(Component, props) : null;
  };
}

function mapStateToProps({user}) {
  return {
    isLoggedIn: Boolean(user)
  };
}

export default compose(
  connect(mapStateToProps),
  withSessionRequired
);